import { useState, useCallback, useEffect } from 'react';
import { Lead } from '../../../types';

export const useKanbanModals = () => {
    // Lead Form Modal (Create/Edit)
    const [isFormModalOpen, setFormModalOpen] = useState(() => {
        if (typeof window !== 'undefined') {
            return sessionStorage.getItem('kanban_form_modal_open') === 'true';
        }
        return false;
    });
    const [preselectedStageId, setPreselectedStageId] = useState<string | null>(null);
    const [selectedLead, setSelectedLead] = useState<Lead | null>(null);

    // Delete Confirmation Modal
    const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
    const [leadToDelete, setLeadToDelete] = useState<Lead | null>(null);

    // Contact Modal
    const [isContactModalOpen, setContactModalOpen] = useState(false);

    useEffect(() => {
        sessionStorage.setItem('kanban_form_modal_open', String(isFormModalOpen));
    }, [isFormModalOpen]);

    // Handlers
    const handleOpenCreateModal = useCallback((stageId?: string) => {
        if (stageId) {
            setPreselectedStageId(stageId);
        }
        setFormModalOpen(true);
    }, []);

    const closeFormModal = useCallback(() => {
        setFormModalOpen(false);
        setPreselectedStageId(null);
        sessionStorage.removeItem('kanban_form_data');
    }, []);

    const handleOpenEditPanel = useCallback((lead: Lead) => {
        setSelectedLead(lead);
        if (typeof window !== 'undefined') {
            sessionStorage.setItem('kanban_open_lead_id', lead.id);
        }
    }, []);

    const handleClosePanel = useCallback(() => {
        setSelectedLead(null);
        if (typeof window !== 'undefined') {
            sessionStorage.removeItem('kanban_open_lead_id');
        }
    }, []);

    const handleOpenDeleteModal = useCallback((lead: Lead) => {
        // Fecha o painel se estiver aberto para evitar inconsistências
        setSelectedLead(null);
        setLeadToDelete(lead);
        setDeleteModalOpen(true);
    }, []);

    const closeDeleteModal = useCallback(() => {
        setDeleteModalOpen(false);
        setLeadToDelete(null);
    }, []);

    const handleOpenContactModal = useCallback(() => setContactModalOpen(true), []);
    const handleCloseContactModal = useCallback(() => setContactModalOpen(false), []);

    return {
        // States
        isFormModalOpen,
        preselectedStageId,
        selectedLead,
        isDeleteModalOpen,
        leadToDelete,
        isContactModalOpen,

        // Actions
        handleOpenCreateModal,
        closeFormModal,
        handleOpenEditPanel,
        handleClosePanel,
        handleOpenDeleteModal,
        closeDeleteModal,
        handleOpenContactModal,
        handleCloseContactModal
    };
};
